<template>
  <div class="tesla-page">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue';
import { Loading, Empty, Dialog, Col, Row } from 'vant';


/**
 * ----------------------------------------------------------------
 * 以下是代码高亮插件
 */
import Hljs from 'highlight.js';
import 'highlight.js/styles/tomorrow-night.css';

Vue.use(Loading).use(Empty).use(Dialog);
Vue.use(Col).use(Row);

const Highlight = {};
Highlight.install = function (Vue) {
  // 自定义指令 v-highlight
  Vue.directive('highlight', {
    // 被绑定元素插入父节点时调用
    inserted(el) {
      try {
        const blocks = el.querySelectorAll('pre code');
        for (let i = 0; i < blocks.length; i++) {
          Hljs.highlightBlock(blocks[i]);
        }
      } catch (error) {
        console.log('Highlight error');
      }
    },
    // 指令所在组件的 VNode 及其子 VNode 全部更新后调用
    componentUpdated(el) {
      try {
        const blocks = el.querySelectorAll('pre code');
        for (let i = 0; i < blocks.length; i++) {
          Hljs.highlightBlock(blocks[i]);
        }
      } catch (error) {
        console.log('Highlight error');
      }
    },
  });
};
Vue.use(Highlight);
/**
 * 以上是代码高亮插件
 * ----------------------------------------------------------------
 */
export default {};
</script>

<style lang="scss" scoped>
.tesla-page {
  width: 100vw;
  height: 100vh;
}
</style>